export default "__VITE_ASSET__55342a95__"